export { default } from "bullitttime-embermodelsgochips/adapters/gochipsModelsAdapter";
